import React, {Component} from 'react';
import {Modal, Button, Icon, Carousel} from 'antd';

function NextArrow(props) {
    const {className, style, onClick} = props;
    return (
        <div className={className} style={{...style, display: 'block'}} onClick={onClick}>
            <Icon type="right" style={{fontSize: 32}}/>
        </div>
    );
}

function PrevArrow(props) {
    const {className, style, onClick} = props;
    return (
        <div className={className} style={{...style, display: 'block'}} onClick={onClick}>
            <Icon type="left" style={{fontSize: 32}}/>
        </div>
    );
}

class AlertConfigurationPagerdutyHelp extends Component {

    state = {
        loading: false,
        visible: false,
    }

    showModal = () => {
        this.setState({visible: true});
    }

    handleOk = (e) => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    render() {
        const {visible, loading} = this.state;

        return (
            <div style={{display: 'inline'}}>
                <Icon type="question-circle-o" onClick={this.showModal} style={{cursor: 'pointer'}}/>
                <Modal visible={visible} title='Quick Help' onOk={this.handleOk} onCancel={this.handleCancel} maskClosable={false} width={800}
                       footer={[
                           <Button key="submit" size="large" loading={loading} onClick={this.handleOk}>Close</Button>
                       ]}>

                    <div style={{margin: 40}}>
                        <Carousel arrows nextArrow={<NextArrow/>} prevArrow={<PrevArrow/>} infinite={false}>
                            <div><img src="../img/pageduty-step-1.png" /></div>
                            <div><img src="../img/pageduty-step-2.png" /></div>
                            <div><img src="../img/pageduty-step-3.png" /></div>
                            <div><img src="../img/pageduty-step-4.png" /></div>
                        </Carousel>
                    </div>

                </Modal>
            </div>
        );
    }
}
export default AlertConfigurationPagerdutyHelp;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationPagerdutyHelp.js